<section class="pt-2">
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-lg-6">
                <div class="section_tittle text-center">
                    <h3>Ready To Go Viral?</h3>
                    <div>
                        <p>Select One of our viral <strong>Buy TikTok {{packDesc}}</strong> packages</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-deck text-center">
            <div *ngFor="let item of packages; let i = index" class="col-lg-4 col-md-6">
                <div class="card mb-3 box-shadow">
                    <div class="card-header">
                        <img loading="lazy" src="assets/icons/pricing_icon_{{i+1}}.png" [alt]="item.description">
                        <h3 class="my-0">{{item.description}}</h3>
                    </div>
                    <div class="card-body">
                        <div class="row justify-content-center pb-3 text-muted" *ngIf="item.old_price">
                            <div>
                                <span class="pricesOld ">
                                    <span>{{symbol}}{{item.old_price * rate | currency: 'code':''}}</span></span>
                            </div>
                            <div>
                                <span class="badge badge-success">
                                    {{((item.old_price - item.price )/ item.old_price) * 100 | number: '1.0-0'}}%
                                    OFF</span>
                            </div>
                        </div>

                        <h3 class="card-title pricing-card-title">{{symbol}}{{item.price * rate | currency: 'code':''}}
                        </h3>
                        <ul class="mb-1">
                            <li>No Password Required</li>
                            <li>Delivery within 0-6 hours</li>
                            <li>100% money back guarantee</li>
                            <li>24/7 online support</li>
                        </ul>
 
                        <div class="row justify-content-center">
                            <button (click)="setPackageId(item)" type="button" class="btn btn-primary btn-lg btn-radius">
                                {{item.description}}</button>
                          </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>